import queryString from 'querystring'
class Url {

    constructor () {
        this.defaultQuery = {
            page: 1,
            sort: '',
            direction: '',
            keyword: ''
        }
    }

    buildQuery (newQuery = {}) {
        const query = queryString.parse(window.location.search.replace('?', ''))

        if (query.page) {
            query.page = parseInt(query.page)
        }

        return {
            ...this.defaultQuery,
            ...query,
            ...newQuery
        }
    }

    getQuery () {
        return queryString.parse(window.location.search.replace('?', ''))
    }
}

export default Url
